import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import SectionHeader from './SectionHeader';
import { brand } from '../../shared-theme/brand';

const steps = [
  {
    title: 'Learn your firm',
    description:
      'Walk us through your practice areas, intake questions, and what a signable case looks like. We build your qualification flows around how your firm actually screens.',
  },
  {
    title: 'Build and test',
    description:
      'We configure your AI agent and run it through real scenarios like car accidents, slip and falls, and after-hours callers before it ever takes a live call.',
  },
  {
    title: 'Go live',
    description:
      'Connect your number and turn it on. Your agent starts answering, texting back, and booking consultations, with our team watching closely through the first week.',
  },
  {
    title: 'Monitor and improve',
    description:
      'Every call is transcribed and scored. We keep tuning your flows, and when you change your criteria, your agent picks it up the same day.',
  },
];

// Onboarding as a four-step timeline. The numbers are the real sequence:
// this is the order it happens in.
export default function HowWeWork() {
  return (
    <Box
      id="how-we-work"
      sx={{
        py: { xs: 8, md: 12 },
        backgroundColor: brand.ivory,
      }}
    >
      <Container maxWidth="lg">
        <SectionHeader
          title="Live in one to two weeks, and we do the work"
          subtitle="No dashboards to learn and no prompts to write. Our team builds, launches, and tunes your intake while you stay focused on cases."
        />
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: 'repeat(4, 1fr)' },
            gap: { xs: 4, md: 5 },
          }}
        >
          {steps.map((step, index) => (
            <Box key={step.title}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 1,
                  borderTop: `1px solid ${brand.sand}`,
                  pt: 2.5,
                  mb: 1.25,
                }}
              >
                <Typography
                  sx={{
                    color: brand.copper,
                    fontSize: '0.875rem',
                    fontWeight: 600,
                    fontVariantNumeric: 'tabular-nums',
                  }}
                >
                  {String(index + 1).padStart(2, '0')}
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 600,
                    letterSpacing: '-0.01em',
                    color: brand.brown,
                    fontSize: '1.075rem',
                  }}
                >
                  {step.title}
                </Typography>
              </Box>
              <Typography
                sx={{
                  color: brand.taupe,
                  fontSize: '0.95rem',
                  lineHeight: 1.65,
                }}
              >
                {step.description}
              </Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
